import { render } from "./AllcardsSection.vue?vue&type=template&id=80f90562&scoped=true"
import script from "./AllcardsSection.vue?vue&type=script&lang=js"
export * from "./AllcardsSection.vue?vue&type=script&lang=js"

import "./AllcardsSection.vue?vue&type=style&index=0&id=80f90562&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80f90562"]])

export default __exports__